"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resizeCanvasTo = void 0;
/**
 * Resizes a canvas. If the width or height changed, the canvas will automatically be cleared.
 *
 * @param size The target size.
 * @param canvas The element to resize.
 */
exports.resizeCanvasTo = function (size, canvas) {
    var width = Math.ceil(size.width);
    var height = Math.ceil(size.height);
    // Note: any set operation on canvas width/height will implicitly cause the
    // canvas to be cleared, even if the old/new values are the same.
    if (canvas.width !== width || canvas.height !== height) {
        canvas.width = width;
        canvas.height = height;
    }
};
//# sourceMappingURL=resizeCanvasTo.js.map